export enum TenantKey {
  PROBATE = 'probate',
  GUARDIANSHIP = 'guardianship',
  MINOR = 'minor',
  TRUST = 'trust',
}
